// @flow
import * as React from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../MuiComponents/FaiTypography";
import pxToRem from "../../../../assets/theme/functions/pxToRem";
import theme from "../../../../assets/theme";
import {Card as MuiCard} from "@mui/material";

type CardProps = {
    bgColor: string;
    color: string;
    icon: any;
    title: string;
    amount: number;
    count: number;
};

const formatAmount = (value: number): string =>
    `Rs. ${(value || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

export const Card = (props: CardProps) => {
    const {typography} = theme;
    const {bgColor, color, icon, title, amount, count} = props;
    return (
        <MuiCard sx={{
            borderRadius: "8px",
            minWidth: "255px",
            height: "196px",
            backgroundColor: bgColor,
        }}>
            <FaiBox p={"16px 35px 16px 35px"}>
                <FaiBox textAlign={"center"}>
                    <FaiBox>
                        <FaiBox mb={1}>
                            <FaiBox component={"img"} src={icon} alt={"icon"} width={"40px"}
                                    height={"40px"}/>
                        </FaiBox>
                        <FaiBox color={color}>
                            <FaiTypography variant={"h6"} fontWeight={typography.fontWeightMedium} mb={"8px"}
                                           color={"inherit"}>
                                {title}
                            </FaiTypography>
                            <FaiTypography variant={"h4"} fontWeight={typography.fontWeightBold}
                                           color={"inherit"}>
                                {formatAmount(amount)}
                            </FaiTypography>
                        </FaiBox>
                    </FaiBox>
                    <FaiBox mt={2}>
                        <FaiTypography variant={"span"} fontSize={pxToRem(12)} color={color}>
                            {count} {count === 1 ? 'order' : 'orders'}
                        </FaiTypography>
                    </FaiBox>
                </FaiBox>
            </FaiBox>
        </MuiCard>
    );
};
